/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { PageInfoFromJSON, PageInfoToJSON } from './PageInfo';
import { RecordPorterHistoryFromJSON, RecordPorterHistoryToJSON } from './RecordPorterHistory';
export function GetRecordPorterHistoriesResponseDataFromJSON(json) {
    return GetRecordPorterHistoriesResponseDataFromJSONTyped(json, false);
}
export function GetRecordPorterHistoriesResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        recordPorterHistories: !exists(json, 'record_porter_histories')
            ? undefined
            : json['record_porter_histories'].map(RecordPorterHistoryFromJSON),
        pageInfo: !exists(json, 'page_info') ? undefined : PageInfoFromJSON(json['page_info'])
    };
}
export function GetRecordPorterHistoriesResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        record_porter_histories: value.recordPorterHistories === undefined
            ? undefined
            : value.recordPorterHistories.map(RecordPorterHistoryToJSON),
        page_info: PageInfoToJSON(value.pageInfo)
    };
}
